import { ShortSpecification } from '@components/display/offer/ShortSpecifications'

import styles from 'styles/OfferShortSpecifications.module.css'
import stylesAlt from 'styles/OfferShortSpecificationsAlt.module.css'

const ShortSpecificationsAlt = ({ offer: {
    part_kind, part_vehicle, part_make, part_producer, part_reference_number,
    category, make, model,
}}) => {

    return (
        <div className={`${styles.specs} ${stylesAlt.specs}`}>
            <ShortSpecification value={part_kind} alt="Rodzaj" showtext={true} />
            <ShortSpecification value={part_vehicle} alt="Pojazd" showtext={true} />
            <ShortSpecification value={category} alt="Kategoria" showtext={true} />
            <ShortSpecification value={part_make || make} alt="Marka" showtext={true} />
            <ShortSpecification value={model} alt="Model" showtext={true} />
            <ShortSpecification value={part_producer} alt="Producent" showtext={true} heading />
            { !part_producer && <ShortSpecification value={part_reference_number} alt="Numer" showtext={true} heading /> }
        </div>
    )
}

export default ShortSpecificationsAlt